import PaymentsTable from "../../Payments/PaymentsTable";

const SubscriptionPayments = ({
    subscriptionDetails,
    payments,
    onEdit,
    onDelete
}) => {
   
    return (
        <div className="mjsdev-dtl-section">
            <div className="mjsdev-dtl-sec-header"><h4>Payment Details</h4></div>
            <div className="mjsdev-dtl-inner-container">
                <h5>Upcoming Payment</h5>
                <div className="mjsdev-dtl-row">
                    <span>Amount</span>
                    <span>${(Number(subscriptionDetails.amount || process.env.REACT_APP_STRIPE_MONTHLY_PRICING)).toFixed(2)}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Due Date</span>
                    <span>
                        {subscriptionDetails?.paused && <i title="Uncollectible" style={{color: "red"}} class="fa-solid fa-circle-exclamation"></i>}
                        {" "}
                        {subscriptionDetails.currentPeriodEnd
                            ? new Date(subscriptionDetails.currentPeriodEnd).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric"
                            })
                            : "—"}
                    </span>
                </div>
            </div>
            <div className="mjsdev-dtl-inner-container">
                <h5>Payment History</h5>
                <PaymentsTable 
                    payments={payments}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            </div>
        </div> 
    );
};

export default SubscriptionPayments;
